import { render, staticRenderFns } from "./IconButton.vue?vue&type=template&id=59198e29&scoped=true&"
import script from "./IconButton.vue?vue&type=script&lang=js&"
export * from "./IconButton.vue?vue&type=script&lang=js&"
import style0 from "./IconButton.vue?vue&type=style&index=0&id=59198e29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59198e29",
  null
  
)

export default component.exports